// Module
var code = "<div *ngIf=\"!isEmailUnlockUser\" class=\"text-light-black text-regular\" style=\"margin-top:-.4rem\" [ngClass]=\"isGroupUserIdsBigModalEnabled ? '' : 'margin-normal'\"> {{ showText() | translate}} </div> <div class=\"bg-gray\" [ngClass]=\"isRebrading ? 'border-radius-12' : ''\"> <i-code></i-code> </div> ";
// Exports
module.exports = code;